export const CK_HASH = "2573984e1c79bf317f5375953acd990a";
export const BACK_URL = 'http://avtomir.dealer-mitsubishi.ru';
export const RESERVE_COOKIES = 'current:::typ=utm|||src=actioncall|||mdm=cpc|||cmp=lpnoscript|||cnt=(none)|||trm=(none)^#^#session:::cpg=http://avtomir.dealer-mitsubishi.ru/^#^#';